export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_SET_ACCESS_TOKEN = 'AUTH_SET_ACCESS_TOKEN'
export const TERMS_AND_CONDITIONS_REQUIRED = 'TERMS_AND_CONDITIONS_REQUIRED'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const CLIENT_TOKEN_ERROR = 'CLIENT_TOKEN_ERROR'
export const CLIENT_TOKEN_REQUEST = 'CLIENT_TOKEN_REQUEST'
export const CLIENT_TOKEN_SUCCESS = 'CLIENT_TOKEN_SUCCESS'
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR'
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR'
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const RESET_CHANGE_PASSWORD_STATUS = 'RESET_CHANGE_PASSWORD_STATUS'
export const VALIDATE_TOKEN='VALIDATE_TOKEN'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_ACTUAL_URL = 'SET_ACTUAL_URL'
export const VALIDATE_TOKEN_SUCCESS ='VALIDATE_TOKEN_SUCCESS'
export const VALIDATE_TOKEN_ERROR='VALIDATE_TOKEN_ERROR'